<template>
  <div>
    <self-back :pageHeaderList="[{'name':'MCN机构全称配置'}]"></self-back>
    <div class="content" v-loading='loading'>
      <div class="clear topBox">
        <div class="left">
          <button class="addaccountButton" @click="addaccountEvent">+ 添加MCN机构全称</button>
        </div>
        <el-input placeholder="请输入名称筛选" v-model.trim="name_search" clearable @keydown.enter.native="name_search?customerListEvent(1):''" @clear="customerListEvent(1)" size="small" style="width:200px;margin-left:15px">
          <el-button slot="append" icon="el-icon-search" @click="customerListEvent(1)" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="customerList" :max-height="tableMaxHeight" border>
        <el-table-column prop="name" label="MCN机构全称" align='center'></el-table-column>
        <el-table-column prop="party_a_ein" label="甲方税号" align="center"></el-table-column>
        <el-table-column prop="party_a_account" label="甲方银行/账号" align="center"></el-table-column>
        <el-table-column prop="party_a_address" label="甲方地址/电话" align="center"></el-table-column>
        <el-table-column prop="service_type" label="发票服务类型" align="center"></el-table-column>
        <el-table-column align='center' width='160' label="操作">
          <template slot-scope="scope">
            <button @click="editAccountEvent(scope.row)">编辑</button>
            <button v-if="scope.row.del_enable==1" style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox" style="height: 30px;">
        <el-pagination small background @current-change="handleCurrentChange" :current-page="page" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <!-- 添加账号 -->
    <el-dialog :title="isEdit?'修改MCN机构全称':'添加MCN机构全称'" :visible.sync="addaccountFlag" width="500px" :close-on-click-modal='false' center>
      <div class="dialogBox">
        <div class="dialogitem">
          <label><em>*</em>MCN机构全称：</label>
          <el-input :disabled="isEdit || serviceTypeOnlyEdit" placeholder="请输入MCN机构全称" style="width:70%" v-model.trim="customer_name" size='small' clearable></el-input>
        </div>
        <div class="dialogitem">
          <label><em v-if="isEdit">*</em>甲方税号：</label>
          <el-input :disabled="serviceTypeOnlyEdit" placeholder="请输入甲方税号" style="width:70%" v-model.trim="party_a_ein" size='small' clearable></el-input>
        </div>
        <div class="dialogitem">
          <label><em v-if="isEdit">*</em>甲方银行/账号：</label>
          <el-input :disabled="serviceTypeOnlyEdit" placeholder="请输入甲方银行/账号" type="textarea" style="width:70%" v-model.trim="party_a_account" size='small' clearable></el-input>
        </div>
        <div class="dialogitem">
          <label><em v-if="isEdit">*</em>甲方地址/电话：</label>
          <el-input :disabled="serviceTypeOnlyEdit" placeholder="请输入甲方地址/电话" type="textarea" style="width:70%" v-model.trim="party_a_address" size='small' clearable></el-input>
        </div>
        <div class="dialogitem">
          <label><em v-if="isEdit">*</em>发票服务类型</label>
          <el-cascader style="width:70%" v-model="serviceData" size="small" :options="invoiceServideOptions" separator='-' clearable></el-cascader>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
        <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      addaccountFlag: false,
      deleteaccountFlag: false,
      customerList: [],
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      isEdit: false,
      customer_name: '',
      party_a_ein: '',
      party_a_account: '',
      party_a_address: '',
      edit_id: '',
      serviceTypeOnlyEdit: false,
      invoiceServideOptions: this.$commonData.invoiceServideOptions,
      serviceData: [],
      name_search: ''
    }
  },
  computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      // Header(60) + self-back(50) + padding(30) + button(30) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 320px
      return window.innerHeight - 260;
    }
  },
  created () {
    this.customerListEvent(1)
  },
  methods: {
    addaccountEvent () {//点击添加账号按钮
      this.addaccountFlag = true;
      this.isEdit = false;
      this.edit_id = '';
      this.customer_name = '';
      this.party_a_ein = '';
      this.party_a_account = '';
      this.party_a_address = '';
      this.serviceTypeOnlyEdit = false;
      this.serviceData = []
    },
    editAccountEvent ({ name, party_a_ein, party_a_account, party_a_address, id, service_type, edit_enable }) {//编辑
      this.addaccountFlag = true;
      this.isEdit = true;
      this.serviceTypeOnlyEdit = edit_enable != 1;
      this.customer_name = name;
      this.party_a_ein = party_a_ein;
      this.party_a_account = party_a_account;
      this.party_a_address = party_a_address;
      this.edit_id = id
      this.serviceData = service_type ? service_type.split('-') : []
    },
    deleteaccountFlagEvent (data) {//删除账号
      this.$confirm('确定要删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.URL.BASEURL + this.URL.mcnDel, {
          id: data.id,
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.customerListEvent(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }).catch(() => {
      });
    },
    handleCurrentChange (val) {
      this.customerListEvent(val)
    },
    customerListEvent (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.mcnList, {
        params: {
          page: page,
          page_size: this.page_size,
          name: this.name_search
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    addaccountYes () {//添加账号
      if (this.customer_name == '') {
        this.$message.warning('请输入MCN机构全称')
        return
      }
      if (this.party_a_ein != '' && this.party_a_ein && this.party_a_ein.length != 18) {
        this.$message.warning('请正确输入18位甲方税号')
        return
      }
      if (this.isEdit && !this.serviceTypeOnlyEdit) {
        if (!this.party_a_ein || this.party_a_ein == '') {
          this.$message.warning('请正确输入18位甲方税号')
          return
        }
        if (!this.party_a_address || this.party_a_address == '') {
          this.$message.warning('请输入甲方地址/电话')
          return
        }
        if (!this.party_a_account || this.party_a_account == '') {
          this.$message.warning('请输入甲方银行/账号')
          return
        }
        if (!this.serviceData || this.serviceData.length == 0) {
          this.$message.warning('请选择发票服务类型')
          return
        }
      }
      if (this.serviceTypeOnlyEdit && (!this.serviceData || this.serviceData.length == 0)) {
        this.$message.warning('请选择发票服务类型')
        return
      }
      this.$loading(this.$loadingConfig)
      let axios_api = this.URL.mcnAdd
      let params = {
        name: this.customer_name,
        party_a_ein: this.party_a_ein,
        party_a_address: this.party_a_address,
        party_a_account: this.party_a_account,
        service_type: this.serviceData.join('-')
      }
      if (this.isEdit) {
        axios_api = this.URL.mcnEdit;
        params.id = this.edit_id
      }
      this.$axios.post(this.URL.BASEURL + axios_api, params).then((res) => {
        this.$loading(this.$loadingConfig).close()
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerListEvent(this.page)
          this.cancelAddaccount()
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    cancelAddaccount () {//取消添加账号
      this.addaccountFlag = false;
      this.customer_name = '';
      this.serviceTypeOnlyEdit = false;
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
  padding: 15px 15px 0;
  // display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - 140px);
  .addaccountButton {
    height: 30px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    border: none;
    padding: 0 10px;
  }
  .table {
    margin-top: 15px;
    button {
      min-width: 48px;
      height: 22px;
      background: #5b7bfe;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      border: none;
      padding: 0 6px;
    }
  }
}
.dialogitem {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  &:last-of-type {
    margin-bottom: 0;
  }
  label {
    display: inline-block;
    width: 120px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    em {
      color: red;
    }
  }
}
.topBox {
  .left {
    float: left;
  }
  .right {
    float: right;
    .lianjie {
      background: #5c7bfe;
      border: none;
      color: #ffffff;
      font-size: 12px;
      line-height: 30px;
      border-radius: 4px;
      padding: 0 8px;
      a {
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/disposeAdmin/mcnConfigure.vue